import type { MilestoneBody, MilestonesOverviewResponse } from '@pulse/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** Every project's milestones, as of now (MS-6). The navigation's badge reads it too. */
export function useMilestonesOverview(options: { readonly enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['milestones'],
    queryFn: () => apiRequest<MilestonesOverviewResponse>('/api/milestones'),
    staleTime: 60_000,
    enabled: options.enabled ?? true,
  });
}

/** MS-6: a new milestone on the project the member picks. */
export function useCreateMilestone() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ project, body }: { readonly project: string; readonly body: MilestoneBody }) => apiRequest(`/api/milestones/${encodeURIComponent(project)}`, { method: 'POST', body }),
    onSuccess: () => client.invalidateQueries({ queryKey: ['milestones'] }),
  });
}
